/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.5.6",
    versionName: "0.2.0-nightly.2026.5.6",
    versionChannel: "nightly",
    buildDate: "2026-05-06T00:24:18.154Z",
    commitHash: "460ba5b032125a0cc27c9afbb08404b21f4d9667",
};
